import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { SSOUser } from '../api/types'

interface AuthSliceState {
  isAuthenticated: boolean
  user: SSOUser | null
  isLoading: boolean
  error: string | null
}

const initialState: AuthSliceState = {
  isAuthenticated: false,
  user: null,
  isLoading: true,
  error: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
      if (action.payload) {
        state.error = null
      }
    },

    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isLoading = false
    },

    clearError: (state) => {
      state.error = null
    },

    loginSuccess: (state, action: PayloadAction<SSOUser>) => {
      state.isAuthenticated = true
      state.user = action.payload
      state.isLoading = false
      state.error = null
    },

    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      state.isLoading = false
      state.error = null
    },

    updateUser: (state, action: PayloadAction<Partial<SSOUser>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
      }
    },
  },
})

export const {
  setLoading,
  setError,
  clearError,
  loginSuccess,
  logout,
  updateUser,
} = authSlice.actions

export default authSlice.reducer
